const validate = (values) => {
  const errors = {};
  if (!values.student) {
    errors.student = 'Selecione um aluno';
  }
  if (!values.measureDate) {
    errors.measureDate = 'Selecione uma data';
  }
  if (!values.height) {
    errors.height = 'Digite uma altura válida';
  } else if (Number(values.height < 10 || values.height > 200)) {
    errors.height = 'Digite uma altura maior do que 9cm e menor que 201cm';
  }
  if (!Number.isInteger(values.height) && values.height === 0) {
    if (values.height.includes('.')) {
      errors.height = 'Informe a medida em centímetros';
    }
  }
  if (!Number.isInteger(values.weight) && !values.weight) {
    errors.weight = 'Informe o peso';
  }
  if (
    !Number.isInteger(values.waistCircumference) &&
    values.waistCircumference
  ) {
    if (values.waistCircumference.includes('.')) {
      errors.waistCircumference = 'Informe a medida em centímetros';
    }
  }
  if (!Number.isInteger(values.headDiameter) && values.headDiameter) {
    if (values.headDiameter.includes('.')) {
      errors.headDiameter = 'Informe a medida em centímetros';
    }
  }
  if (values.height && values.measureDate) {
    const { historicalData, height, measureDate } = values;
    if (historicalData && historicalData.length) {
      let firstBefore;
      let firstAfter;
      historicalData.forEach((item) => {
        if (item.measureDate < measureDate) {
          firstBefore = !firstBefore ? item : firstBefore;
        }
        if (item.measureDate > measureDate) {
          firstAfter = item;
        }
      });
      let isValidRecord = true;
      if (firstAfter) {
        isValidRecord = isValidRecord && height <= firstAfter.height;
      }
      if (firstBefore) {
        isValidRecord = isValidRecord && height >= firstBefore.height;
        if (!isValidRecord && height >= firstBefore.height) {
          errors.height =
            'Altura informada é maior que uma informada posteriormente';
        } else if (!isValidRecord && height <= firstBefore.height) {
          errors.height =
            'Altura informada é menor que uma informada anteriormente';
        }
      }
    }
  }
  if (!values.weight) {
    errors.weight = 'Digite um peso';
  } else if (Number(values.weight) <= 0 || Number(values.weight) > 150) {
    errors.weight = 'Digite um peso maior do que 0 e menor 151 ';
  }
  if (Number(values.headDiameter) < 0) {
    errors.headDiameter = 'Digite uma medida de cabeça válida';
  }
  if (Number(values.waistCircumference) < 0) {
    errors.waistCircumference = 'Digite uma circunferência abdominal válida';
  }
  return errors;
};
export default validate;
